import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-input-serial-number',
    templateUrl: './input-serial-number-wrapper.html',
})
export class FormlyInputSerialNumberWrapperComponent extends FieldWrapper { }
